/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';

/**
 * 
 * @export
 * @interface CreateSeasonRequest
 */
export interface CreateSeasonRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonRequest
     */
    name: string;
    /**
     * 
     * @type {any}
     * @memberof CreateSeasonRequest
     */
    seasonStartDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof CreateSeasonRequest
     */
    seasonEndDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof CreateSeasonRequest
     */
    onlineRegistrationStartDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof CreateSeasonRequest
     */
    onlineRegistrationEndDate?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeasonRequest
     */
    chargeRegistrationFee?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeasonRequest
     */
    isContinuous?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateSeasonRequest
     */
    tuition?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateSeasonRequest
     */
    tuitionRatePlanId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSeasonRequest
     */
    tuitionDiscountIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeasonRequest
     */
    isFeatured?: boolean | null;
}

/**
 * Check if a given object implements the CreateSeasonRequest interface.
 */
export function instanceOfCreateSeasonRequest(value: object): value is CreateSeasonRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('seasonStartDate' in value) || value['seasonStartDate'] === undefined) return false;
    if (!('seasonEndDate' in value) || value['seasonEndDate'] === undefined) return false;
    return true;
}

export function CreateSeasonRequestFromJSON(json: any): CreateSeasonRequest {
    return CreateSeasonRequestFromJSONTyped(json, false);
}

export function CreateSeasonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSeasonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'seasonStartDate': json['seasonStartDate'],
        'seasonEndDate': json['seasonEndDate'],
        'onlineRegistrationStartDate': json['onlineRegistrationStartDate'] == null ? undefined : json['onlineRegistrationStartDate'],
        'onlineRegistrationEndDate': json['onlineRegistrationEndDate'] == null ? undefined : json['onlineRegistrationEndDate'],
        'chargeRegistrationFee': json['chargeRegistrationFee'] == null ? undefined : json['chargeRegistrationFee'],
        'isContinuous': json['isContinuous'] == null ? undefined : json['isContinuous'],
        'tuition': json['tuition'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'tuitionRatePlanId': json['tuitionRatePlanId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['tuitionRatePlanId']),
        'tuitionDiscountIds': json['tuitionDiscountIds'] == null ? undefined : json['tuitionDiscountIds'],
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
    };
}

export function CreateSeasonRequestToJSON(json: any): CreateSeasonRequest {
    return CreateSeasonRequestToJSONTyped(json, false);
}

export function CreateSeasonRequestToJSONTyped(value?: CreateSeasonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'seasonStartDate': value['seasonStartDate'],
        'seasonEndDate': value['seasonEndDate'],
        'onlineRegistrationStartDate': value['onlineRegistrationStartDate'],
        'onlineRegistrationEndDate': value['onlineRegistrationEndDate'],
        'chargeRegistrationFee': value['chargeRegistrationFee'],
        'isContinuous': value['isContinuous'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'tuitionRatePlanId': ActorActivityRecordActorUserIdToJSON(value['tuitionRatePlanId']),
        'tuitionDiscountIds': value['tuitionDiscountIds'],
        'isFeatured': value['isFeatured'],
    };
}

